import CustomCarousel from 'components/CustomCarousel';
import { AutoInfoCard } from 'components/ItemInfoCard';
import messages from 'containers/AUTODashboard/Body/MyContracts/messages';
import { StyledSmallSectionHeader } from 'containers/AUTODashboard/Body/MyContracts/styles';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { CONTRACT_STATUSES } from 'utils/globalConst';

const MyContracts = (props: {
  intl: IntlShape;
  contractsAuto: [];
  setDetailsPageBreadcrumbsPath: Function;
}) => {
  return (
    <>
      <StyledSmallSectionHeader>
        {translate({ ...messages.title }, props)}
      </StyledSmallSectionHeader>
      <CustomCarousel showIndicators={props.contractsAuto.length > 1}>
        {props.contractsAuto.map(
          (
            contract: {
              status: string;
              autoBrand: string;
              deadline: string;
              contractNumber: string;
            },
            index,
          ) => (
            <AutoInfoCard
              setDetailsPageBreadcrumbsPath={
                props.setDetailsPageBreadcrumbsPath
              }
              key={index}
              status={
                contract.status === CONTRACT_STATUSES.ACTIVE
                  ? 'success'
                  : 'error'
              }
              statusLabel={
                contract.status === CONTRACT_STATUSES.ACTIVE
                  ? translate({ ...messages.Actif }, props)
                  : translate({ ...messages.Encours }, props)
              }
              title={contract.autoBrand}
              dateValue={contract.deadline}
              numValue={contract.contractNumber}
              wrapperPaddingRight={
                index === props.contractsAuto.length - 1 ? '24px' : '45px'
              }
              wrapperPaddingLeft={index === 0 ? '24px' : '45px'}
            />
          ),
        )}
      </CustomCarousel>
    </>
  );
};

export default injectIntl(MyContracts);
